export default __webpack_public_path__ + "static/media/disconnect.18d6e472.svg";